// 自定义数字键
<template>
  <div class="CustomNumberKeyboard" v-if="isShow2">
    <div class="top">
      <span class="btn"></span>
      <!-- <span class="btn finish">完成</span> -->
    </div>
    <div class="grid-list">
      <span class="grid" v-for="(item, index) in 9" :key="index" @click="inputValue(index+1)">{{index+1}}</span>
      <span class="grid space"></span>
      <span class="grid" @click="inputValue(0)">0</span>
      <span class="grid delete" @click="deleteValue"></span>
    </div>
  </div>
</template>

<script>
import { showToast, showLoading, hideLoading } from '../../../../static/js/utility/utility';
import axios from 'axios'
import * as config from '../../../../static/js/config.js';

export default {
  name:'CustomNumberKeyboard',
  props: ['isShow'],
  data(){
    return {
      isShow2: this.isShow
    }
  },
  created(){
    console.log('isShow', this.isShow)
  },
  mounted(){
  },
  computed: {
    // isShow2 () {
    //   return this.isShow
    // }
  },
  methods:{
    // 输入值
    inputValue (num) {
      this.$emit('getInputValue', num)
    },
    // 删除值
    deleteValue () {
      this.$emit('deleteValue')
    },
    // 切换键盘显示状态
    switchShow () {
      this.isShow2 = !(this.isShow2)
    }
  },
  watch:{

  }
}
</script>

<style lang="scss">
  .CustomNumberKeyboard {
    width: 100%;
    padding-bottom: 0.5rem;
    background-color: #d2d3d7;
    position: fixed;
    bottom: 0;
    left: 0;
    .top {
      width: 100%;
      padding: 0 0.1rem;
      height: 0.65rem;
      line-height: 0.65rem;
      display: flex;
      justify-content: space-between;
      .btn {

      }
      .btn.finish {
        font-size: 0.24rem;
        color: #4589cf;
        font-weight: bold;
        padding:  0 0.2rem;
      }
    }
    .grid-list {
      width: 100%;
      padding-left: 0.1rem;
      text-align: center;
      display: flex;
      flex-wrap: wrap;
      .grid {
        width: 2rem;
        height: 0.75rem;
        line-height: 0.75rem;
        margin-right: 0.1rem;
        margin-bottom: 0.1rem;
        border-radius: 0.06rem;
        font-size: 0.3rem;
        font-weight: 500;
        color: #000000;
        background-color: #ffffff;
        box-shadow: 0 2px 5px -2px #757575;

      }
      .grid:active {
        background-color: #b8c2cf;
      }
      .grid.space,
      .grid.delete {
        background-color: #d2d3d7;
        box-shadow: 0 0 0 0 #000000;
      }
      .grid.delete {
        background: url('../../../../static/images/icon/icon_delete.png') center no-repeat;
        background-size: 0.45rem auto;
      }
      .grid.delete:active {
        background: url('../../../../static/images/icon/icon_delete_active.png') center no-repeat;
        background-size: 0.45rem auto;
      }
    }
  }
</style>




// WEBPACK FOOTER //
// src/components/PhonePage/PrivacyCabinet/CustomNumberKeyboard.vue